export const FUND_TRANSFER = 'fund-transfer';
export const FUND_TRANSFER_TYPE_DEPOSIT = 'deposit';
export const FUND_TRANSFER_TYPE_WITHDRAW = 'withdraw';

export const FUND_TRANSFER_INTERNAL_BALANCE_TYPE = 'casino_gaming_balance';
